import { configureStore } from "@reduxjs/toolkit"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import { program_slice } from "./slices/collection/program/slice"
import { advertising_slice } from "./slices/collection/advertising/slice"
import { demand_slice } from "./slices/collection/demand/slice"
import { admin_slice } from "./slices/collection/user/admin/slice"
import { client_slice } from "./slices/collection/user/client/slice"
import { operator_slice } from "./slices/collection/user/operator/slice"
import { subscription_slice } from "./slices/collection/subscription/slice"
import { comment_slice } from "./slices/collection/comment/slice"
import { privilege_slice } from "./slices/collection/privilege/slice"
import { session_slice } from "./slices/session/slice"
import { realtime_slice } from "./slices/realtime/slice"
import { RealtimeMiddleware } from "./slices/realtime/middleware"
import { client_connected_slice } from "./slices/collection/user_connected/client/slice"
import { admin_connected_slice } from "./slices/collection/user_connected/admin/slice"
import { operator_connected_slice } from "./slices/collection/user_connected/operator/slice"
import { header_pin_slice } from "./slices/other/header_pin/slice"
import { participation_slice } from "./slices/participation/slice"
import { message_slice } from "./slices/collection/message/slice"
import { guest_connected_slice } from "./slices/collection/user_connected/guest/slice"
import { live_slice } from "./slices/live/slice"
import { actuality_slice } from "./slices/collection/actuality/slice"
import { cache_slice } from "./slices/cache/slice"
import { program_record_slice } from "./slices/collection/progam_record/slice"
import { stream_record_slice } from "./slices/collection/stream_record/slice"
import { audio_slice } from "./slices/audio/slice"
import { payement_slice } from "./slices/collection/payement/slice"
import { reporting_slice } from "./slices/collection/reporting/slice"
import { advertising_plan_slice } from "./slices/collection/advertising_plan/slice"
import { flux_slice } from "./slices/collection/flux/slice"
import { notification_slice } from "./slices/notification/slice"
import { playlist_slice } from "./slices/collection/playlist/slice"

const store = configureStore({
  reducer: {
    program_slice,
    advertising_slice,
    demand_slice,
    admin_slice,
    client_slice,
    operator_slice,
    subscription_slice,
    comment_slice,
    privilege_slice,
    session_slice,
    realtime_slice,
    client_connected_slice,
    admin_connected_slice,
    operator_connected_slice,
    header_pin_slice,
    participation_slice,
    message_slice,
    guest_connected_slice,
    live_slice,
    actuality_slice,
    cache_slice,
    program_record_slice,
    stream_record_slice,
    audio_slice,
    payement_slice,
    reporting_slice,
    advertising_plan_slice,
    flux_slice,
    notification_slice,
    playlist_slice
  },
  middleware: (gDMs) => gDMs().concat(RealtimeMiddleware)
})

export type rootState = ReturnType<typeof store.getState>
export type rootDispatch = typeof store.dispatch
type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<rootState> = useSelector

export default store